import { useState } from 'react';

// from https://twitter.com/TkDodo/status/1653418107103264774/photo/2
export const usePrevious = <T>(value: T): T | undefined => {
  const [current, setCurrent] = useState<T>(value);
  const [previous, setPrevious] = useState<T>();

  if (value !== current) {
    setPrevious(current);
    setCurrent(value);
  }

  return previous;
};
